import { useSyncExternalStore } from 'react';
import { type Maybe } from '@models/Maybe';

const registry = new Map<string, string>();
const listeners = new Set<() => void>();

const emit = (): void => {
    listeners.forEach((listener) => {
        listener();
    });
};

export const registerCopyProjectName = (
    projectID: string,
    projectName: string,
): void => {
    registry.set(projectID, projectName);
    emit();
};

export const getCopyProjectName = (projectID: string): Maybe<string> =>
    registry.get(projectID) ?? null;

const subscribe = (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

export const useCopyProjectName = (projectID: Maybe<string>): Maybe<string> =>
    useSyncExternalStore(subscribe, () =>
        projectID ? getCopyProjectName(projectID) : null,
    );
